import { removeLegacySector } from '../../Hooks/useSectorMigration';
import { setAppInsightsUser } from '../../Hooks/withApplicationInsight';
import CreateTableContext from './TableContext';
const basicProfileFields = [
    "contactid",
    "firstname",
    "lastname",
    "emailaddress1",
    "telephone1",
    "address1_city",
    "jobtitle",
    "mcb_linkedin",
    "mcb_mainqualification",
    "mcb_myabcs",
    "mcb_sectors",
    "adx_publicprofilecopy",
    "mcb_has_cliftonstrength",
];

const relations = {
    "mcb_IdealRole": "mcb_role"
}

const mcbCliftonStrengthFields = [];
for(let c = 1; c <= 10; c++) mcbCliftonStrengthFields.push(`mcb_cliftonstrength_${c}`);

const readOnly = ["mcb_clifton34pdf", "mcb_cliftonstrengthstop5pdf", "mcb_signaturethemepdf", "mcb_themesequencepdf", "modifiedon"];

function convertTableData(tableData) {
    
    if (Array.isArray(tableData) && tableData[0]) {
        const profileData = {};
        const associate = fieldKey => {
            profileData[fieldKey] = tableData[0][fieldKey];
        };
        basicProfileFields.forEach(associate);
        Object.keys(relations).forEach((columnName) => {
            const columnKey = `_${columnName.toLowerCase()}_value`;
            associate(columnKey);
        });
        readOnly.forEach(a => profileData[a] = tableData[0][a]);
        profileData.topCliftonStrengths = mcbCliftonStrengthFields.map(key => tableData[0][key]);
        profileData.sectors = (tableData[0].mcb_sectors?.length? tableData[0].mcb_sectors.split(",") : []).filter(a => a && !isNaN(a)).map(a => Number(a));
        return profileData;
    }
}

function convertFormData(formData, baseData) {
    if (typeof formData === "object" && formData) {
        const tableData = {...baseData};
        basicProfileFields.forEach(fieldKey => {
            tableData[fieldKey] = formData[fieldKey];
        });
        Object.keys(relations).forEach((columnName) => {
            const columnKey = `_${columnName.toLowerCase()}_value`;
            tableData[columnKey] = formData[columnKey];
        });
        const topCliftonStrengths = formData.topCliftonStrengths || [];
        for (let c = 0; c < 10; c++) {
            tableData[`mcb_cliftonstrength_${c + 1}`] = topCliftonStrengths[c];
        }
        tableData.mcb_sectors = removeLegacySector(formData.sectors || []).join(",");
        if (tableData.mcb_sectors === "") tableData.mcb_sectors = null;
        return tableData;
    }
}

function processContextData ({
    datas, addData, updateData, deleteData,
    uploadFileToData, downloadFileFromData,
    ...context
}) {
    const profileData = convertTableData(datas);
    if (!window.context) window.context = {};
    if (!window.context.user) window.context.user = {...profileData};
    else Object.assign(window.context.user, profileData);
    window.context.user.name = `${window.context.user.firstname} ${window.context.user.lastname}`;
    setAppInsightsUser(window.context.user.contactid);
    return {
        profileData,
        updateProfile: (formData, ...args) => updateData(convertFormData(formData, profileData), ...args), 
        uploadProfileFile: (field, file, ...args) => datas?.length && uploadFileToData(datas[0]?.contactid, field, file, ...args),
        downloadProfileFile: (field, ...args) =>   datas?.length && downloadFileFromData(datas[0]?.contactid, field, ...args),
        ...context
    };
}

const [useProfile, ProfileProvider] = CreateTableContext(
    "contact", { processContextData, relations, fields: [...basicProfileFields, ...mcbCliftonStrengthFields], readOnly }
);

export default useProfile;
export { useProfile, ProfileProvider };
